import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SortDialogData {
  sortBy: string;
  sortDirection: 'asc' | 'desc';
}

@Component({
  selector: 'app-version-store-sort-dialog',
  templateUrl: './version-store-sort-dialog.component.html',
  styleUrls: ['./version-store-sort-dialog.component.scss']
})
export class VersionStoreSortDialogComponent {
  sortBy: string = 'VersionName'; // default
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private dialogRef: MatDialogRef<VersionStoreSortDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SortDialogData
  ) {
    if (data) {
      this.sortBy = data.sortBy || 'versionName';
      this.sortDirection = data.sortDirection || 'asc';
    }
  }

  onApply() {
  this.dialogRef.close({
    sortBy: this.sortBy,
    sortDirection: this.sortDirection
  });
}

  close() {
    this.dialogRef.close();
  }
}
